import { render, staticRenderFns } from "./automatic_marking.vue?vue&type=template&id=6ae059cb&scoped=true"
import script from "./automatic_marking.vue?vue&type=script&lang=js"
export * from "./automatic_marking.vue?vue&type=script&lang=js"
import style0 from "./automatic_marking.vue?vue&type=style&index=0&id=6ae059cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae059cb",
  null
  
)

export default component.exports